import bp from './brakePoints';

let $timeline = $('.time-line'),
	$timelinePresentation = $timeline.find('.time-line__presentation'),
	$time = $timelinePresentation.find('.time-line__time'),
	$marks = $timeline.find('.time-line__mark'),
	$start = $timeline.find('.time-line__start'),
	$finish = $timeline.find('.time-line__finish');

if ($timeline.length > 0) {
	let start = 0,
		finish = 0,
		timelineTop = 0,
		timeHeight = 0,
		animated = false;
	
	const items = [];
	
	const offset = function() {
		return ['phone-big'].includes(bp.current) ? 16 : 24;
	};
	
	prepare();
	onResize();
	animate();
	$(window).resize(onResize);
	
	function prepare() {
		timelineTop = $timeline.offset().top;
		$marks.each(function() {
			let $c = $(this),
				mark;
			if ($c.hasClass('time-line__mark_big')) {
				mark = $('<div class="time-line__big"></div>');
			} else {
				mark = $('<div class="time-line__small"></div>');
			}
			
			$timelinePresentation.append(mark);
			
			let item = {
				parent: $c,
				mark: mark,
				isBig: $c.hasClass('time-line__mark_big'),
				top: 0,
				appeared: false
			};
			items.push(item);
		});
	}
	
	function onResize() {
		timelineTop = $timeline.offset().top;
		start = $start.offset().top - timelineTop + offset();
		finish = $timeline.height() - ($finish.offset().top - timelineTop + offset());
		
		$timelinePresentation.css({
			top: start,
			bottom: finish
		});
		if (animated) {
			$time.height($timelinePresentation.height());
		}
		items.forEach(function(value) {
			if (value.isBig) {
				value.top = value.parent.offset().top - timelineTop;
			} else {
				value.top = value.parent.offset().top - timelineTop;
			}
			
			value.mark.css({
				top: value.top + 'px'
			});
		});
	}
	
	function animate() {
		let remain = items.filter(item => !item.appeared);
		if ($timelinePresentation.height() > timeHeight) {
			$time.css({height: timeHeight});
			remain.forEach(function(value) {
				if (!value.appeared && value.top <= timeHeight) {
					value.mark.addClass('appeared');
					value.appeared = true;
				}
			});
			timeHeight += 16;
			
		} else if ($timelinePresentation.height() <= timeHeight) {
			items[items.length - 1].mark.addClass('appeared');
			items[items.length - 1].appeared = true;
			animated = true;
		}
		if (remain.length > 0) {
			requestAnimationFrame(animate);
		}
	}
}
